import { PortfolioReviewBucket } from "creso-core/types";

export type HoldingColumnKey =
  | "source"
  | "quartile"
  | "xirr"
  | "invested"
  | "current"
  | "weight"
  | "stcg"
  | "ltcg";

// Fund name and Action are always shown, so they are not toggleable.
export const HOLDING_COLUMNS: {
  key: HoldingColumnKey;
  label: string;
  group: "visible" | "general";
}[] = [
  { key: "source", label: "Source", group: "visible" },
  { key: "quartile", label: "3Y Quartile", group: "visible" },
  { key: "xirr", label: "XIRR", group: "visible" },
  { key: "invested", label: "Invested", group: "visible" },
  { key: "current", label: "Current", group: "visible" },
  { key: "weight", label: "% Holdings", group: "general" },
  { key: "stcg", label: "STCG", group: "general" },
  { key: "ltcg", label: "LTCG", group: "general" },
];

export const DEFAULT_VISIBLE_COLUMNS: HoldingColumnKey[] =
  HOLDING_COLUMNS.filter((c) => c.group === "visible").map((c) => c.key);

export const BUCKET_GROUPS: { bucket: PortfolioReviewBucket; label: string }[] =
  [
    { bucket: "SWITCH", label: "Funds to switch" },
    { bucket: "EXIT", label: "Funds to exit" },
    { bucket: "HOLD", label: "Funds to hold" },
    { bucket: "NEW_ADDITION", label: "New additions" },
  ];
